import { Player } from './player';
import { Hole } from './course';

export interface CreateRoundRequest {
    name: string;
    ownerPlayerId: string;
    courseId?: string;
}

export interface CreateRoundResponse {
    id: string;
    name: string;
    date: string;
    created_at: string;
    expires_at?: string;
}

export interface GetRoundRequest {
    id: string;
}

export interface GetRoundResponse {
    id: string;
    name: string;
    date: string;
    status: string;
    players: Player[];
}

export interface Round {
    id: string;
    name: string;
    date: string;
    status: string;
    expires_at?: string;
    player?: Player;
    players: Player[];
    holes?: Hole[];
    courseId?: string;
    courseName?: string;
    ownerPlayerId?: string;
}

export enum RoundStatus {
    NEW = 'NEW',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
}
